import React from "react";

import {
  useNavigate,
  useParams,
} from "react-router-dom";

import { useCart } from "../../components/CartContext";

import "./css/CartScreen.css";


function CartScreen() {

  const {
    restaurantId,
    tableId,
  } = useParams();

  const navigate =
    useNavigate();


  /* =====================================================
     CART
  ===================================================== */

  const {
    cart,
    cartCount,
    cartTotal,
    increaseQuantity,
    decreaseQuantity,
    removeFromCart,
    clearCart,
  } = useCart();


  /* =====================================================
     BACK TO MENU
  ===================================================== */

  const goBackToMenu = () => {

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  /* =====================================================
     CHECKOUT
  ===================================================== */

  const goCheckout = () => {

    navigate(
      `/${restaurantId}/table/${tableId}/checkout`
    );

  };


  return (

    <div className="theme2-cart-screen">

      <div className="theme2-cart-container">


        {/* =================================================
            CART HEADER
        ================================================= */}

        <div className="theme2-cart-heading">

          <span>
            YOUR ORDER
          </span>


          <h1>
            CART
          </h1>


          <p>
            {cartCount}{" "}
            {cartCount === 1
              ? "ITEM"
              : "ITEMS"}
          </p>

        </div>


        {/* =================================================
            EMPTY CART
        ================================================= */}

        {cart.length === 0 ? (

          <div
            className="theme2-cart-empty"
          >

            <h2>
              Your cart is empty
            </h2>


            <p>
              Choose something delicious
              from our menu.
            </p>


            <button
              type="button"
              onClick={goBackToMenu}
            >
              VIEW MENU
            </button>

          </div>

        ) : (

          <>


            {/* =============================================
                CART ITEMS
            ============================================== */}

            <div className="theme2-cart-items">

              {cart.map(
                (item) => (

                  <article
                    className="theme2-cart-item"
                    key={item.id}
                  >


                    {/* =====================================
                        ITEM IMAGE
                    ====================================== */}

                    <div
                      className="theme2-cart-item-image"
                    >

                      {item.image ? (

                        <img
                          src={item.image}
                          alt={item.name}
                        />

                      ) : (

                        <div
                          className="theme2-cart-item-no-image"
                        >
                          NO IMAGE
                        </div>

                      )}

                    </div>


                    {/* =====================================
                        ITEM INFORMATION
                    ====================================== */}

                    <div
                      className="theme2-cart-item-info"
                    >

                      <h2>
                        {item.name}
                      </h2>


                      <p>
                        {item.description ||
                          "Freshly prepared from our kitchen."}
                      </p>

                    </div>


                    {/* =====================================
                        QUANTITY
                    ====================================== */}

                    <div
                      className="theme2-cart-item-actions"
                    >

                      <button
                        type="button"
                        onClick={() =>
                          decreaseQuantity(
                            item.id
                          )
                        }
                        aria-label={
                          `Decrease ${item.name}`
                        }
                      >
                        −
                      </button>


                      <span>
                        {item.quantity}
                      </span>


                      <button
                        type="button"
                        onClick={() =>
                          increaseQuantity(
                            item.id
                          )
                        }
                        aria-label={
                          `Increase ${item.name}`
                        }
                      >
                        +
                      </button>

                    </div>


                    {/* =====================================
                        ITEM TOTAL
                    ====================================== */}

                    <div
                      className="theme2-cart-item-total"
                    >

                      ₹
                      {(
                        Number(item.price) *
                        Number(item.quantity)
                      ).toFixed(2)}

                    </div>


                    {/* =====================================
                        REMOVE
                    ====================================== */}

                    <button
                      type="button"
                      className="theme2-cart-remove"
                      onClick={() =>
                        removeFromCart(
                          item.id
                        )
                      }
                    >
                      REMOVE
                    </button>

                  </article>

                )
              )}

            </div>


            {/* =============================================
                CART SUMMARY
            ============================================== */}

            <div
              className="theme2-cart-summary"
            >

              <div>

                <span>
                  TOTAL
                </span>


                <strong>
                  ₹
                  {Number(
                    cartTotal
                  ).toFixed(2)}
                </strong>

              </div>


              <div
                className="theme2-cart-summary-actions"
              >

                <button
                  type="button"
                  className="theme2-cart-continue"
                  onClick={
                    goBackToMenu
                  }
                >
                  CONTINUE ORDER
                </button>


                <button
                  type="button"
                  className="theme2-cart-checkout"
                  onClick={
                    goCheckout
                  }
                >
                  CHECKOUT
                </button>

              </div>


              <button
                type="button"
                className="theme2-cart-clear"
                onClick={
                  clearCart
                }
              >
                CLEAR CART
              </button>

            </div>

          </>

        )}

      </div>

    </div>

  );

}


export default CartScreen;